// src/components/home/GallerySection.jsx
import React, { useState, useEffect, useRef } from 'react';

// Gallery images
import gallery1 from '../../assets/img40.jpg';
import gallery2 from '../../assets/img14.jpg';
import gallery3 from '../../assets/img118.jpg';
import gallery4 from '../../assets/img44.jpg';
import gallery5 from '../../assets/img51.jpg';
import gallery6 from '../../assets/img73.jpg';
import gallery7 from '../../assets/img113.jpg';
import gallery8 from '../../assets/img123.jpg';
import gallery9 from '../../assets/img33.jpg';

const GallerySection = () => {
  const galleryImages = [
    { src: gallery1, alt: 'Treatment Room', caption: 'Panchakarma Therapy Room' },
    { src: gallery2, alt: 'Herbal Garden', caption: 'Organic Herbal Garden' },
    { src: gallery3, alt: 'Yoga Session', caption: 'Morning Yoga & Meditation' },
    { src: gallery4, alt: 'Ayurvedic Meal', caption: 'Sattvic Healing Meals' },
    { src: gallery5, alt: 'Wellness Center', caption: 'Wellness center room' },
    { src: gallery6, alt: 'Therapy Room', caption: 'Wellness center room' },
    { src: gallery7, alt: 'Treatment Area', caption: 'Wellness center room' },
    { src: gallery8, alt: 'Reception', caption: 'Wellness center room' },
    { src: gallery9, alt: 'Garden View', caption: 'Wellness center room' },
  ];

  // Gallery slider state (used by multiple gallery sections)
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isPaused, setIsPaused] = useState(false);
    const intervalRef = useRef(null);
    const nextSlide = () => setCurrentIndex((prev) => (prev + 1) % galleryImages.length);
    const prevSlide = () => setCurrentIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
    const galleryGoTo = (index) => setCurrentIndex(index);
    useEffect(() => {
      if (isPaused) return;
      intervalRef.current = setInterval(() => {
        nextSlide();
      }, 3000);
      return () => {
        if (intervalRef.current) clearInterval(intervalRef.current);
      };
    }, [isPaused]); 
  

  return (
    <section className="bg-[#E4DED5] text-center py-16 sm:py-20 px-4 sm:px-6 md:px-16 font-poppins">
  {/* Header */}
  <div className="mb-10 sm:mb-14 px-2">
    <button className="inline-block text-[#0B2A2C] px-4 sm:px-6 py-2 rounded-full text-xl font-medium mb-4 sm:mb-6 border border-[#0B2A2C]">
       Gallery
    </button>
    <h2 className="text-[#13381F] text-3xl sm:text-4xl md:text-5xl font-playfair font-semibold mt-4 sm:mt-5 mb-2">
       Explore our serene healing spaces and treatments
    </h2>
    <p className="text-[#4B4B4B] text-sm sm:text-base md:text-lg px-2">
      Witness our world class hospitality & unforgetable ambiance
    </p>
  </div>
{/* Auto-Scrolling Gallery */}
<div className="relative max-w-full sm:max-w-6xl mx-auto overflow-hidden group">
  <div
    className="flex transition-transform duration-500 ease-in-out"
    style={{ transform: `translateX(-${currentIndex * 100}%)` }}
    onMouseEnter={() => setIsPaused(true)}
    onMouseLeave={() => setIsPaused(false)}
  >
    {galleryImages.map((image, index) => (
      <div key={index} className="w-full flex-shrink-0 px-1 sm:px-2">
        <div className="relative rounded-xl overflow-hidden shadow-lg">
          {/* Image */}
          <img
            src={image.src}
            alt={image.alt}
            className="w-full h-48 sm:h-64 md:h-80 object-cover"
          />
          {/* Transparent White Caption Bar */}
          <div className="absolute bottom-0 left-0 right-0 bg-white/55 backdrop-blur-md py-2 sm:py-3 px-2 sm:px-4 border-t border-white/30">
            <p className="text-[#204E40] font-bold text-sm sm:text-base md:text-lg text-center">
              {image.caption}
            </p>
          </div>
        </div>
      </div>
    ))}
  </div>
    {/* Left Arrow - Responsive padding */}
    <button
      onClick={prevSlide}
      className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white text-[#204E37] p-1.5 sm:p-2 rounded-full shadow-md opacity-0 group-hover:opacity-100 transition-opacity"
      aria-label="Previous image"
    >
      <svg className="w-4 h-4 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
      </svg>
    </button>
    {/* Right Arrow */}
    <button
      onClick={nextSlide}
      className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white text-[#204E37] p-1.5 sm:p-2 rounded-full shadow-md opacity-0 group-hover:opacity-100 transition-opacity"
      aria-label="Next image"
    >
      <svg className="w-4 h-4 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
      </svg>
    </button>
    {/* Dot Indicators - Responsive spacing */}
    <div className="flex justify-center gap-1 sm:gap-2 mt-4 sm:mt-6">
      {galleryImages.map((_, index) => (
        <button
          key={index}
          onClick={() => galleryGoTo(index)}
          className={`w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full transition-all duration-300 ${
            index === currentIndex
              ? 'bg-[#204E37] w-5 sm:w-8'
              : 'bg-[#C9C1B7] hover:bg-[#204E37]'
          }`}
          aria-label={`Go to slide ${index + 1}`}
        />
      ))}
    </div>
  </div>
</section>
  );
};

export default GallerySection;